import {
  BlockRenderer as BlockRendererEnum,
  determinePreferredRenderer,
  type StreamingChatId,
  type StreamingBlock,
} from "@storytell/streaming";
import { Match, Switch } from "solid-js";
import {
  ArtifactViewerRenderer,
  BlockPreview,
  InterstitialDataRenderer,
  InterstitialRenderer,
  InterstitialUserFacingRenderer,
  UnknownRenderer,
  UserFacingMessage,
} from "./r";

export const BlockRenderer = (props: { block: StreamingBlock; chatId: StreamingChatId }) => {
  const preferredRenderer = () => determinePreferredRenderer(props.block);
  return (
    <Switch>
      <Match when={preferredRenderer() === BlockRendererEnum.INTERSTITIAL}>
        <InterstitialRenderer block={props.block} />
      </Match>
      <Match
        when={
          preferredRenderer() === BlockRendererEnum.USER_FACING_MESSAGE ||
          preferredRenderer() === BlockRendererEnum.INTERSTITIAL_CATCH
        }
      >
        <UserFacingMessage block={props.block} />
      </Match>

      <Match when={preferredRenderer() === BlockRendererEnum.INTERSTITIAL_DATA}>
        <InterstitialDataRenderer block={props.block} />
      </Match>

      <Match when={preferredRenderer() === BlockRendererEnum.INTERSTITIAL_USER_FACING}>
        <InterstitialUserFacingRenderer block={props.block} />
      </Match>

      <Match when={preferredRenderer() === BlockRendererEnum.ARTIFACT_VIEWER}>
        <ArtifactViewerRenderer block={props.block} />
      </Match>

      <Match when={preferredRenderer() === BlockRendererEnum.BLOCK_PREVIEW}>
        <BlockPreview block={props.block} onClick={() => {}} />
      </Match>

      <Match when={true}>
        <UnknownRenderer block={props.block} />
      </Match>
    </Switch>
  );
};
